import Container from '../../components/layout/Container'
import TabPanel from "../../components/navigation/Tab"
import { useState } from 'react'
import Comunicacoes from "../MinhasComunicacoes/Comunicacoes"
import PrivateRoute from '../../auth/private-route'
import ControleAcessoService from "../../services/ControleAcessoService"
import { useEffect } from 'react'
import { Grid, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import EnumEtapasComunicacao from '../../enums/enumEtapasComunicacao'

export default function AcompanhamentoComunicacoes(props) {
    const [recarregarComunicacoes, setRecarregarComunicacoes] = useState('')
    const [listaOrgaosJurisdicionados, setListaOrgaosJurisdicionados] = useState([])
    const [orgaoJurisdicionadoSelecionado, setOrgaoJurisdicionadoSelecionado] = useState({ code: 0, label: '' })

    const tabs = [
        {
            idOrgaoJurisdicionado: orgaoJurisdicionadoSelecionado.code,
            title: "Pendentes de Ciência",
            etapa: EnumEtapasComunicacao.PendenteCiencia,
            itens: Comunicacoes,
            recarregar: { recarregarComunicacoes },
            setRecarregar: (value) => setRecarregarComunicacoes(value)
        },
        {
            idOrgaoJurisdicionado: orgaoJurisdicionadoSelecionado.code,
            title: "Pendentes de Resposta",
            etapa: EnumEtapasComunicacao.PendenteResposta,
            itens: Comunicacoes,
            recarregar: { recarregarComunicacoes },
            setRecarregar: (value) => setRecarregarComunicacoes(value)
        },
        {
            idOrgaoJurisdicionado: orgaoJurisdicionadoSelecionado.code,
            title: "Aguardando Triagem TCE-GO",
            etapa: EnumEtapasComunicacao.PendenteTriagem,
            itens: Comunicacoes,
            recarregar: { recarregarComunicacoes },
            setRecarregar: (value) => setRecarregarComunicacoes(value)
        },
        {
            idOrgaoJurisdicionado: orgaoJurisdicionadoSelecionado.code,
            title: "Aguardando Deliberações",
            etapa: EnumEtapasComunicacao.PendenteLiberacao,
            itens: Comunicacoes,
            recarregar: { recarregarComunicacoes },
            setRecarregar: (value) => setRecarregarComunicacoes(value)
        },
        {
            idOrgaoJurisdicionado: orgaoJurisdicionadoSelecionado.code,
            title: "Respondidas/Encerradas",
            etapa: EnumEtapasComunicacao.RespondidaEncerrada,
            itens: Comunicacoes,
            recarregar: { recarregarComunicacoes },
            setRecarregar: (value) => setRecarregarComunicacoes(value)
        }
    ]

    useEffect(() => {
        const obtenhaListaOrgaosJurisdicionados = (listaOrgaosJurisdicionados) => {
            let _listaOrgaosJurisdicionados = []
            let _listaFinalOrgaosJurisdicionados = []

            if (listaOrgaosJurisdicionados !== undefined && listaOrgaosJurisdicionados.length > 0) {
                _listaOrgaosJurisdicionados = listaOrgaosJurisdicionados.map(
                    function (row) {
                        return { code: row.id, label: row.nome }
                    }
                )
            }

            // Não define órgão pré-selecionado, pois o usuário sempre será usuário interno do TCE.
            setOrgaoJurisdicionadoSelecionado({ code: 0, label: '' })

            if (_listaOrgaosJurisdicionados.length > 0) {
                // Se existir o órgão TCE na lista, este órgão deve ser removido, pois não existe comunicações para o próprio TCE.
                _listaFinalOrgaosJurisdicionados = _listaOrgaosJurisdicionados.filter(orgao => orgao.code !== 119)
            }

            return _listaFinalOrgaosJurisdicionados
        }

        const definaOrgaosJurisdicionadosUsuario = () => {
            ControleAcessoService.ConsultaOrgaosUsuario()
                .then(response => {
                    setListaOrgaosJurisdicionados(obtenhaListaOrgaosJurisdicionados(response.data))
                })
        }

        definaOrgaosJurisdicionadosUsuario()
    }, [])

    const onChangeAutocompleteOrgaoJurisdicionadoUsuario = (orgaoJurisdicionadoUsuario) => {
        setOrgaoJurisdicionadoSelecionado(orgaoJurisdicionadoUsuario)
    }

    return (
        <PrivateRoute rolesAllowed={props.roles}>
            <Container
                title={'Comunicações'}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Autocomplete
                        id='indice-orgao-jurisdicionado'
                        options={listaOrgaosJurisdicionados}
                        disabled={listaOrgaosJurisdicionados.length <= 1}
                        clearText={'Limpar'}
                        openText={'Expandir'}
                        closeText={'Recolher'}
                        noOptionsText={'Nenhum resultado encontrado'}
                        value={orgaoJurisdicionadoSelecionado}
                        getOptionSelected={(option) => option.label}
                        getOptionLabel={(option) => option.label || ''}
                        onChange={
                            (event, newValue) => {
                                if (newValue !== null &&
                                    newValue.code !== null &&
                                    newValue.code !== undefined) {
                                    onChangeAutocompleteOrgaoJurisdicionadoUsuario({ code: newValue.code, label: newValue.label })
                                }
                            }
                        }
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Órgão Jurisdicionado"
                                variant="outlined"
                                inputProps={{
                                    ...params.inputProps
                                }}
                            />
                        )}
                    />
                </Grid>
                <br />

                <div id="ContainerPage">
                    <TabPanel tabs={tabs} />
                </div>
                <br /><br /><br /><br />
            </Container >
        </PrivateRoute>
    )
}